import { utilityVerificationGaps, type Utility } from "@cs2/contracts/domain";
import { Badge } from "../ui/Badge.js";

/**
 * Verifizierungsstatus als Pille — eine Quelle für Karte, Detail-Dialog und
 * Utility-Editor. Der Tooltip sagt, was bis zur automatischen Verifikation
 * noch fehlt; einen Button zum Verifizieren gibt es nicht mehr.
 */
export function UtilityStatusBadge({ utility }: { utility: Utility }) {
  const title = verificationTooltip(utility);
  return utility.verificationState === "verified" ? (
    <Badge tone="success" title={title}>
      Verifiziert
    </Badge>
  ) : (
    <Badge tone="warning" title={title}>
      Capture offen
    </Badge>
  );
}

/** Tooltip-Text aus denselben Lücken, aus denen der Server den Status ableitet. */
export function verificationTooltip(utility: Utility): string {
  if (utility.verificationState === "verified")
    return utility.verifiedOn
      ? `Automatisch verifiziert am ${germanDate(utility.verifiedOn)}`
      : "Automatisch verifiziert";
  const gaps = utilityVerificationGaps(utility);
  const parts = [
    gaps.missingMedia.length
      ? `Start-, Ziel- und Ergebnisbild hochladen · ${utility.frames.length - gaps.missingMedia.length}/${utility.frames.length} vorhanden`
      : null,
    gaps.missingTrajectory ? "Trajektorie wird beim Speichern berechnet" : null,
    gaps.missingTechnique ? "Wurfart wählen" : null,
  ].filter(Boolean);
  return parts.length
    ? parts.join(" · ")
    : "Wird beim nächsten Speichern verifiziert";
}

function germanDate(isoDate: string): string {
  const [year, month, day] = isoDate.split("-");
  return `${day}.${month}.${year}`;
}
